import laravelAxiosClient from "../laravelAxiosClient";
import { MotifsSupportResult } from "../interfaces/motif-support.interface";

export const findAllMotifsSupport = async () => {
  const { data } = await laravelAxiosClient.get<MotifsSupportResult>(
    "/motifs-ticket-support"
  );
  return data;
};
